// Extracted from FleetList: unit-testable standalone and reused in SiteEnvironments' per-env display.
import type { ConnectionState } from '../../lib/types';

const STYLES: Record<ConnectionState, string> = {
  connected: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  disconnected: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  error: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  unknown: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  // Host-level outage (e.g. Docker daemon down) — own hue, not reused red/amber.
  unavailable: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
  // Never brought up locally — inert, not an error; muted but kept legible on a white row.
  never: 'bg-slate-100 text-slate-500 dark:bg-slate-900/40 dark:text-slate-500',
};

const LABELS: Record<ConnectionState, string> = {
  connected: 'Connected',
  disconnected: 'Disconnected',
  error: 'Error',
  unknown: 'Unknown',
  unavailable: 'Unavailable',
  never: 'Never',
};

export function ConnectionBadge({ state }: { state: ConnectionState }) {
  return (
    <span
      data-id="em-mgr--fleet--connection-badge"
      className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[state]}`}
    >
      {LABELS[state]}
    </span>
  );
}
